module.exports = __webpack_public_path__ + "691533317da32ee441867f5a5291ec87.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-condensed-regular-webfont.svg
// module id = 439
// module chunks = 0